import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiFieldTypes } from "@/types/custom-field.types.ts";
import {
  ApiCompensationTypeEnum,
  ApiOfferSalarySave,
  getOfferSalaryTypeTitle,
} from "@/types/recruit/offer.types.ts";

export interface OfferSystemFieldDisplayValues {
  date_start: Date | null;
  legal_entity: string | null;
  location: string | null;
  manager: string | null;
  salary: ApiOfferSalarySave | null;
}

export interface OfferSystemFieldValue {
  title: string;
  caption?: string;
}

export function useOfferSystemFieldValue() {
  const { renderDate, renderCurrency } = useFormatter();

  return (
    type: ApiFieldTypes,
    values: OfferSystemFieldDisplayValues
  ): OfferSystemFieldValue | null => {
    switch (type) {
      case ApiFieldTypes.offer_date_start:
        return values.date_start ? { title: renderDate(values.date_start) } : null;
      case ApiFieldTypes.offer_legal_entity:
        return values.legal_entity ? { title: values.legal_entity } : null;
      case ApiFieldTypes.offer_location:
        return values.location ? { title: values.location } : null;
      case ApiFieldTypes.offer_manager:
        return values.manager ? { title: values.manager } : null;
      case ApiFieldTypes.offer_salary: {
        const salary = values.salary;
        if (!salary?.salary_value) return null;
        if (salary.salary_type === ApiCompensationTypeEnum.custom) {
          return { title: salary.salary_value };
        }
        return {
          title: renderCurrency(
            salary.salary_value.replace(",", "."),
            salary.currency_code ?? null
          ),
          caption: salary.salary_type ? getOfferSalaryTypeTitle(salary.salary_type) : undefined,
        };
      }
      default:
        return null;
    }
  };
}
